import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import tools from "../../QS420/QS420_tools";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";
var SAVE_PATH3 = "";
var SAVE_PATH4 = "";

var backfillHistoryData = function backfillHistoryData(_this) {
  var trusteeInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH, {}),
      proOrdInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH2, {}),
      investInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH3, {}),
      detailInvestInfo = _.cloneDeepGet(_this.historyData, "DETAIL_DATA.INVEST_INFO", {}),
      detailTrusteeInfo = _.cloneDeepGet(_this.historyData, "DETAIL_DATA.PRO_TRUSTEE_INFO", {}),
      shareregInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH4, {});

  _Object$assign({}, trusteeInfo, proOrdInfo, investInfo, shareregInfo);
  proOrdInfo.PRO_ORD = proOrdInfo.PRO_ORD_NAME;
  _this.$blMethod.parseGroupsMouduleData(_this, ["PRO_TRUSTEE_INFO", "PRO_ORD_INFO", "INVEST_INFO", "SHAREREG_INFO"], _Object$assign({}, trusteeInfo, proOrdInfo, investInfo, shareregInfo, detailInvestInfo, detailTrusteeInfo));
};

var initFieldConfig = function initFieldConfig(_this) {
  _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.IS_PRO_TRUSTEE.FIELD_TYPE = "radio";
  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.IS_INVEST_ADVISER.FIELD_TYPE = "radio";

  _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.PRO_TRUSTEE_ID_TYPE.FIELD_DICT_NAME = _.filter(_this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.PRO_TRUSTEE_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "1";
  });
  _this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].FIELDS.PRO_ORD_ID_TYPE.FIELD_DICT_NAME = _.filter(_this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].FIELDS.PRO_ORD_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && (item.DICT_ITEM[0] == "1" || item.DICT_ITEM[0] == "0");
  });
  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVESTASER_ID_TYPE.FIELD_DICT_NAME = _.filter(_this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVESTASER_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "1";
  });
  _this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_ID_TYPE.FIELD_DICT_NAME = _.filter(_this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "1";
  });
  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVEST_REP_ID_TYPE.FIELD_DICT_NAME = _.filter(_this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVEST_REP_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
  });

  _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.PRO_TRUSTEE_NAME.VALID_TYPE = "length[0,120]";
  _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.PRO_TRUSTEE_ID_CODE.VALID_TYPE = "length[0,48]";

  _this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].FIELDS.PRO_ORD.VALID_TYPE = "length[0,120]";

  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVESTASER_ID_CODE.VALID_TYPE = "length[0,48]";
  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVEST_REP_ID_CODE.VALID_TYPE = "length[0,48]";
  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVEST_ADVISER.VALID_TYPE = "length[0,64]";
  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVEST_REP.VALID_TYPE = "length[0,64]";
  _this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_ID_CODE.VALID_TYPE = "";
  _this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_NAME.VALID_TYPE = "length[0,64]";

  _this.groupDatas.OTHER_INFO_PAGE.INVEST_INFO[0].FIELDS.INVEST_ORG_TYPE.FIELD_DICT_NAME = [{ DICT_ITEM: "1", DICT_ITEM_NAME: "证券期货经营机构" }, { DICT_ITEM: "2", DICT_ITEM_NAME: "私募证券投资基金管理人" }, { DICT_ITEM: "99", DICT_ITEM_NAME: "其他" }];
};

var update = function update(_this) {
  var module = _this.groupDatas[GROUP_ID][MODULE_ID][0];
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  var _loop = function _loop(key) {
    var funcArr = _.get(fields[key], "FIELD_FUNCTION", "").split("|");
    _.each(funcArr || [], function (func) {
      NODE[func] && NODE[func](_this, fields[key], fields, module);
    });
  };

  for (var key in fields) {
    _loop(key);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
    SAVE_PATH3 = params.savePath3;
    SAVE_PATH4 = params.savePath4;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var trusteeFields, proOrdFields, investFields, shareregFields, PRO_TRUSTEE_INFO, PRO_ORD_INFO, INVEST_INFO, SHAREREG_INFO, code, str, i, initProCls, proCls;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              trusteeFields = bizPublicSaveMethod.getModuleObjctFoyKey(_this, "PRO_TRUSTEE_INFO", [SAVE_PATH], true), proOrdFields = bizPublicSaveMethod.getModuleObjctFoyKey(_this, "PRO_ORD_INFO", [SAVE_PATH2], true), investFields = bizPublicSaveMethod.getModuleObjctFoyKey(_this, "INVEST_INFO", [SAVE_PATH3], true), shareregFields = bizPublicSaveMethod.getModuleObjctFoyKey(_this, "SHAREREG_INFO", [SAVE_PATH4], true);
              PRO_TRUSTEE_INFO = {}, PRO_ORD_INFO = {}, INVEST_INFO = {}, SHAREREG_INFO = {};
              code = "";

              if (trusteeFields.PRO_TRUSTEE_ID_TYPE == "10") {
                str = trusteeFields.PRO_TRUSTEE_ID_CODE.slice(8, 17).split("");

                for (i = 0; i < str.length; i++) {
                  if (i < str.length - 2 || i >= str.length - 1) {
                    code += str[i];
                  } else {
                    code += str[i];
                    code += "-";
                  }
                }
              }

              if (trusteeFields.IS_PRO_TRUSTEE == "1") {
                PRO_TRUSTEE_INFO = {
                  PRO_TRUSTEE_NAME: trusteeFields.PRO_TRUSTEE_NAME,
                  PRO_TRUSTEE_ID_TYPE: trusteeFields.PRO_TRUSTEE_ID_TYPE,
                  PRO_TRUSTEE_ID_CODE: trusteeFields.PRO_TRUSTEE_ID_CODE,
                  PRO_TRUSTEE_ID_EXP_DATE: trusteeFields.PRO_TRUSTEE_ID_EXP_DATE,
                  PRO_TRUSTEE_ASSI_CODE: code
                };
              } else {
                PRO_TRUSTEE_INFO = {
                  PRO_TRUSTEE_NAME: "",
                  PRO_TRUSTEE_ID_TYPE: "",
                  PRO_TRUSTEE_ID_CODE: "",
                  PRO_TRUSTEE_ID_EXP_DATE: ""
                };
              }
              initProCls = _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE;
              proCls = initProCls ? initProCls.slice(0, 2) : "";

              if (["03", "08", "12", "14a", "16", "24"].includes(initProCls) || ["23"].includes(proCls)) {
                PRO_ORD_INFO = {
                  PRO_ORD_NAME: proOrdFields.PRO_ORD,
                  PRO_ORD_ID_TYPE: proOrdFields.PRO_ORD_ID_TYPE,
                  PRO_ORD_ID_CODE: proOrdFields.PRO_ORD_ID_CODE,
                  PRO_ORD_ID_EXP_DATE: proOrdFields.PRO_ORD_ID_EXP_DATE
                };
              } else {
                PRO_ORD_INFO = {
                  PRO_ORD_NAME: "",
                  PRO_ORD_ID_TYPE: "",
                  PRO_ORD_ID_CODE: "",
                  PRO_ORD_ID_EXP_DATE: ""
                };
              }
              if (investFields.IS_INVEST_ADVISER == "1") {
                INVEST_INFO = {
                  INVEST_ADVISER: investFields.INVEST_ADVISER,
                  INVEST_ORG_TYPE: investFields.INVEST_ORG_TYPE,
                  INVESTASER_ID_TYPE: investFields.INVESTASER_ID_TYPE,
                  INVESTASER_ID_CODE: investFields.INVESTASER_ID_CODE,
                  INVEST_REP: investFields.INVEST_REP,
                  INVEST_REP_ID_TYPE: investFields.INVEST_REP_ID_TYPE,
                  INVEST_REP_ID_CODE: investFields.INVEST_REP_ID_CODE
                };
              } else {
                INVEST_INFO = {
                  INVEST_ADVISER: "",
                  INVEST_ORG_TYPE: "",
                  INVESTASER_ID_TYPE: "",
                  INVESTASER_ID_CODE: "",
                  INVEST_REP: "",
                  INVEST_REP_ID_TYPE: "",
                  INVEST_REP_ID_CODE: ""
                };
              }
              SHAREREG_INFO = {
                SHAREREG_ORG_NAME: shareregFields.SHAREREG_ORG_NAME,
                SHAREREG_ORG_TYPE: shareregFields.SHAREREG_ORG_TYPE,
                SHAREREG_ORG_ID_TYPE: shareregFields.SHAREREG_ORG_ID_TYPE,
                SHAREREG_ORG_ID_CODE: shareregFields.SHAREREG_ORG_ID_CODE
              };

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], PRO_TRUSTEE_INFO);
              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH2], PRO_ORD_INFO);
              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH3], INVEST_INFO);
              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH4], SHAREREG_INFO);

              _.set(params, SAVE_PATH, _Object$assign({}, _.get(params, SAVE_PATH, {}), PRO_TRUSTEE_INFO));

              _.set(params, SAVE_PATH2, _Object$assign({}, _.get(params, SAVE_PATH2, {}), PRO_ORD_INFO));

              _.set(params, SAVE_PATH3, _Object$assign({}, _.get(params, SAVE_PATH3, {}), INVEST_INFO));

              _.set(params, SAVE_PATH4, _Object$assign({}, _.get(params, SAVE_PATH4, {}), SHAREREG_INFO));

              params.DETAIL_DATA.PRO_TRUSTEE_INFO = {
                IS_PRO_TRUSTEE: trusteeFields.IS_PRO_TRUSTEE
              };
              params.DETAIL_DATA.INVEST_INFO = {
                IS_INVEST_ADVISER: investFields.IS_INVEST_ADVISER
              };

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),
  pageActivated: function pageActivated(_this, groupId) {
    if (_this.groupDatas.OCR_ORG_INFO_PAGE.ZD_MODULE[0].FIELDS.CUSTOMER_TYPE.DEFAULT_VALUE == "1") {
      _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.IS_PRO_TRUSTEE.DEFAULT_VALUE = "1";
    }
    var initProCls = _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE;
    var proCls = initProCls ? initProCls.slice(0, 2) : "";

    if (["03", "08", "12", "14a", "16", "24"].includes(initProCls) || ["23"].includes(proCls)) {
      _this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].MODULE_CONTROL = "1";
    } else {
      _this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].MODULE_CONTROL = "0";
    }

    if (["23"].includes(proCls)) {
      var proOrdInfoFields = _this.groupDatas.OTHER_INFO_PAGE.PRO_ORD_INFO[0].FIELDS;
      if (!proOrdInfoFields.PRO_ORD.DEFAULT_VALUE && !proOrdInfoFields.PRO_ORD_ID_TYPE.DEFAULT_VALUE && !proOrdInfoFields.PRO_ORD_ID_CODE.DEFAULT_VALUE) {
        proOrdInfoFields.PRO_ORD.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.PRO_MANAGER_NAME.DEFAULT_VALUE;
        proOrdInfoFields.PRO_ORD_ID_TYPE.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_TYPE.DEFAULT_VALUE;
        proOrdInfoFields.PRO_ORD_ID_CODE.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE.DEFAULT_VALUE;
        if (_this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_EXP_DATE.DEFAULT_VALUE) {
          proOrdInfoFields.PRO_ORD_ID_EXP_DATE.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_EXP_DATE.DEFAULT_VALUE;
        }
      }
    }

    var SHAREREG_ORG_REG = ["01", "03", "04", "05", "08", "12", "13", "14", "15", "16", "23"];
    if (!_.includes(SHAREREG_ORG_REG, proCls)) {
      _this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_TYPE.FIELD_REQUIRED = "0";
      _this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_NAME.FIELD_REQUIRED = "0";
      _this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_ID_TYPE.FIELD_REQUIRED = "0";
      _this.groupDatas.OTHER_INFO_PAGE.SHAREREG_INFO[0].FIELDS.SHAREREG_ORG_ID_CODE.FIELD_REQUIRED = "0";
    }
  },

  update: update,
  CHECK_IS_PRO_TRUSTEE: function CHECK_IS_PRO_TRUSTEE(_this, field, fieldData) {
    if (_this.groupDatas.OCR_ORG_INFO_PAGE.ZD_MODULE[0].FIELDS.CUSTOMER_TYPE.DEFAULT_VALUE == "1") {
      if (field.DEFAULT_VALUE == "0") {
        field.DEFAULT_VALUE = "1";
        alert("证券账户开户类型为托管人，则托管人必填！");
      }
    }
    if (field.DEFAULT_VALUE == "1") {
      fieldData.PRO_TRUSTEE_NAME.FIELD_CONTROL = "0";
      fieldData.PRO_TRUSTEE_ID_TYPE.FIELD_CONTROL = "0";
      fieldData.PRO_TRUSTEE_ID_CODE.FIELD_CONTROL = "0";
      fieldData.PRO_TRUSTEE_ID_EXP_DATE.FIELD_CONTROL = "0";
    } else {
      fieldData.PRO_TRUSTEE_NAME.FIELD_CONTROL = "1";
      fieldData.PRO_TRUSTEE_ID_TYPE.FIELD_CONTROL = "1";
      fieldData.PRO_TRUSTEE_ID_CODE.FIELD_CONTROL = "1";
      fieldData.PRO_TRUSTEE_ID_EXP_DATE.FIELD_CONTROL = "1";
    }
  },
  CHECK_IS_INVEST_ADVISER: function CHECK_IS_INVEST_ADVISER(_this, field, fieldData) {
    if (field.DEFAULT_VALUE == "1") {
      _.each(fieldData, function (item) {
        if (item.FIELD_ID == "IS_INVEST_ADVISER") {
          return true;
        }
        item.FIELD_CONTROL = "0";
      });
    } else {
      _.each(fieldData, function (item) {
        if (item.FIELD_ID == "IS_INVEST_ADVISER") {
          return true;
        }
        item.FIELD_CONTROL = "1";
      });
    }
  },
  CHECK_PRO_TRUSTEE_ID_TYPE: function CHECK_PRO_TRUSTEE_ID_TYPE(_this, field, fieldData) {
    _.set(fieldData, "PRO_TRUSTEE_ID_CODE.VALID_TYPE", _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    _.set(fieldData, "PRO_TRUSTEE_ID_CODE.DEFAULT_VALUE", "");
  },
  CHECK_SHAREREG_ORG_ID_TYPE: function CHECK_SHAREREG_ORG_ID_TYPE(_this, field, fieldData) {
    _.set(fieldData, "SHAREREG_ORG_ID_CODE.VALID_TYPE", _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    _.set(fieldData, "SHAREREG_ORG_ID_CODE.DEFAULT_VALUE", "");
  },
  CHECK_PRO_ORD_ID_TYPE: function CHECK_PRO_ORD_ID_TYPE(_this, field, fieldData) {
    _.set(fieldData, "PRO_ORD_ID_CODE.VALID_TYPE", _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    _.set(fieldData, "PRO_ORD_ID_CODE.DEFAULT_VALUE", "");
  },
  CHECK_SHAREREG_PRO_ORD_ID_CODE: function CHECK_SHAREREG_PRO_ORD_ID_CODE(_this, field, fieldData) {
    if (field.LAST_DEFAULT_VALUE == field.DEFAULT_VALUE) {
      return;
    }
    field.LAST_DEFAULT_VALUE = field.DEFAULT_VALUE;
    field.DEFAULT_VALUE && _this.$blMethod.isDisabledLongTime(_this, fieldData.PRO_ORD_ID_TYPE.DEFAULT_VALUE, field.DEFAULT_VALUE, fieldData.PRO_ORD_ID_EXP_DATE);
  },
  CHECK_INVEST_REP_ID_TYPE: function CHECK_INVEST_REP_ID_TYPE(_this, field, fieldData) {
    _.set(fieldData, "INVEST_REP_ID_CODE.VALID_TYPE", _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    _.set(fieldData, "INVEST_REP_ID_CODE.DEFAULT_VALUE", "");
  },
  CHECK_INVESTASER_ID_TYPE: function CHECK_INVESTASER_ID_TYPE(_this, field, fieldData) {
    _.set(fieldData, "INVESTASER_ID_CODE.VALID_TYPE", _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    _.set(fieldData, "INVESTASER_ID_CODE.DEFAULT_VALUE", "");
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/bizPro/bizProOtherInfo.js
// module id = 213
// module chunks = 2